


























































































































































































































































































import { Vue, photosUrlEnum } from "../../constants/constants";
import {
  validateRestaurantMinOrderValue,
  updatePhotosURL
} from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import { BasketLoadersEnum } from "../../models/basket.model";
import shareOrderModal from './share-order-modal.vue'
var modalOpened = false;

export default Vue.component("order-details", {
  components:{
    "share-order-modal":shareOrderModal
  },
  data() {
    return {
      staticContent,
      photosUrlEnum,
      basketLoader: BasketLoadersEnum,
      trackingStates: ["Placed", "Accepted", "Out for delivery", "Delivered"]
    };
  },
  props: ["page"],
  mounted() {
  
    this.$root.isRTL
      ? (this.trackingStates = [
          `في انتظار رد المطعم`,
          `الأوردر بيتحضر`,
          `الأوردر خرج في الطريق`,
          `الأوردر وصل`
        ])
      : (this.trackingStates = [
          "Placed",
          "Accepted",
          "Out for delivery",
          "Delivered"
        ]);
  },

  computed: {
    orderPageLoader(){
      return this.$root.orderPageLoader;

    },
    myOrdersPageLoader() {
      return this.$store.state.myOrdersPageLoader;
    },
    myOrdersPageError() {
      return this.$store.state.myOrdersPageError;
    },
    profile() {
      return this.$store.getters.getProfileData;
    },
    flatAreas() {
      return this.$root.flatAreas;
    },
    deliveryStatus() {
      return this.$root.deliveryStatus;
    },

    OrderType() {
      return this.$store.state.selectedOrderType;
    },

    selectedOrder() {
      return this.$store.state.selectedOrder;
    },
    isMyOrderDelivered() {
      return this.$root.isMyOrderDelivered;
    },
    orderStatus() {
      return this.$root.orderStatus;
    },
    cancelCurrentOrder() {
      return this.$root.cancelCurrentOrder;
    },
    currentOrders() {
      return this.$store.state.currentOrders.data;
    },
    previousOrders() {
      return this.$store.state.previousOrders.data;
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    }
  },

  methods: {
    modalToggler(modalId, action) {
      this.$root.modalToggler(modalId, action);
    },
    backToList() {
      document
        .getElementById("orders-controller")
        .classList.remove("my-orders-mobile");
      document
        .getElementById("orders-details")
        .classList.add("my-orders-mobile");
    },
    closeOrderDetails() {
      return this.$root.closeOrderDetails();
    },
    getMyOrdersLoadingDataError() {
      return this.$root.myOrdersLoadingDataError;
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
    newCalcExtrasTotalPrice(total) {
      return this.$root.newCalcExtrasTotalPrice(total);
    },
    getOrderItemsCount(item) {
      return this.$root.getOrderItemsCount(item);
    },
    basketLoadersEnum() {
      return this.$root.basketLoadersEnum;
    },
    getMyOrdersGroupUsers() {
      return this.$root.getMyOrdersGroupUsers;
    },
    toggleActive(id, type, orderType, orderUUID) {
      this.$root.toggleActive(id, type, orderType, orderUUID);
    },
    tabsHandler(parentId, targetId) {
      this.$root.tabsHandler(parentId, targetId);
    },
    getMyOrdersLoadingData() {
      return this.$root.myOrdersLoadingData;
    },

    openChatWindow(orderUUID) {
      this.$root.openChatWindow(orderUUID);
    },
    getURL(url) {
      return this.$root.updatePhotosURL(
        url,
        this.$root.photosUrlEnum.version.thumbnail
      );
    },
    dateFromNow(date) {
      return this.$root.dateFromNow(date);
    },
    formatAMPM(date) {
      return this.$root.formatAMPM(date);
    },
    setOrderDelivered(orderUUID) {
      this.$root.setOrderDelivered(orderUUID);
    },
    selectOrderToCancel(orderUUID) {
      this.$root.selectOrderToCancel(orderUUID);
    },
    reOrder(UUID) {
      this.$root.handleReOrder(UUID);
    },
    shareOrder(shortCode){
      this.$store.commit('UpdateSharedOrderUrl',window.location.origin+'/orders/'+shortCode);
        this.modalToggler("share-order-modal", "show");
    }
  }
});
